import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GridComponent, PageChangeEvent } from '@progress/kendo-angular-grid';
import {
  SortDescriptor,
  State
} from '@progress/kendo-data-query';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../loader/loader.service';
import { ApiService } from '../service/api.service';
import { groupCurrentPage, withoutGroups } from '../common/grid-grouping';
import { GridSettingsService } from '../service/grid-settings.service';
import { eyeIcon } from '@progress/kendo-svg-icons';

@Component({
    selector: 'app-error-log',
    templateUrl: './error-log.component.html',
    styleUrls: ['./error-log.component.css'],
    providers: [DatePipe],
    standalone: false
})
export class ErrorLogComponent implements OnInit, AfterViewInit {
  readonly icons = {
    view: eyeIcon,
  };

  @ViewChild("grid", { static: true }) gridKendo: GridComponent;
  kendoLoading = false;
  public gridData: any;
  public errorData: any;
  public kendoGridLoading = false;
  public kendoData: any;
  state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
    group: [],
  };
  public sort: SortDescriptor[] = [];
  searchString: any = '';
  columnList: any = [];
  dialogRef!: MatDialogRef<any>;
  selectedRecord: any;
  selectdErrorData: any;
  total = 0;
  public gridHeight: number;
  public pageableWithAll: any = {
    buttonCount: 5,
    pageSizes: [5, 10, 20, 50, 100, { text: 'All', value: 'all' }]
  };
  TableName = "ErrorLog";
  constructor(
    private api: ApiService,
    private toaster: ToastrService,
    private LoaderService: LoaderService,
    public datePipe: DatePipe,
    private readonly dialog: MatDialog,
    private readonly gridSettings: GridSettingsService
  ) { }

  ngOnInit(): void {
    this.columnList.push('Message', 'Source', 'User', 'TimeUtc', 'AllXml');
    this.loadData();
    this.setGridHeight();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setGridHeight();
  }

  setGridHeight(): void {
    const headerHeight = 70; // Adjust according to your header and other elements
    const footerHeight = 61;
    const otherElementsHeight = 125;
    this.gridHeight = window.innerHeight - headerHeight - footerHeight - otherElementsHeight;
  }
  clearList() {
    this.searchString = '';
    this.loadData();
  }
  public dataStateChange(state: any): void {
    this.state = state;
    this.loadData();
  }
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.loadData();
  }
  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.loadData();
  }
  loadData() {
    if (this.searchString == null) {
      this.searchString = "";
    }
    this.LoaderService.show();
    this.total = 0;
    // Error rows carry the full error XML and the table is very large, so unlike the other grids
    // grouping here only covers the current page rather than loading every matching row
    this.api.getAllError(withoutGroups(this.state), JSON.stringify(this.searchString.trim())).subscribe(
      (res) => {
        if ((res['Success'] == true)) {
          this.LoaderService.hide();
          res['Data'].Item1.forEach((e: any, i: any) => {
            e.TimeUtc = e.TimeUtc.split('T')[0];
            e.TimeUtc = this.datePipe.transform(
              new Date(e.TimeUtc),
              'dd-MM-yyyy'
            );
          });
          this.errorData = res['Data'].Item1;
          this.total = res['Total'];
          this.gridData = groupCurrentPage(this.errorData, this.total, this.state);
        } else {
          this.errorData = [];
          this.total = 0;
          this.gridData = {
            data: this.errorData,
            total: this.total,
          };
          this.LoaderService.hide();
        }
      },
      (err) => {
        this.total = 0;
        this.errorData = [];
        this.gridData = {
          data: this.errorData,
          total: this.total,
        };
        this.LoaderService.hide();
        this.toaster.error('Something went wrong Record not Updated sorry');
      }
    );
  }
  getByIdError() {
    this.LoaderService.show();
    this.api.getByIdError(this.selectedRecord.ErrorId).subscribe(
      (res) => {
        if ((res['Success'] = true)) {
          this.selectdErrorData = res['Data'];
          this.LoaderService.hide();
        } else {
          this.selectdErrorData = [];
          this.LoaderService.hide();
          this.toaster.error('Error');
        }
      },
      (err) => {
        this.LoaderService.hide();
        this.toaster.error('Something went wrong Record not Updated sorry');
      }
    );
  }
  filterData(event: any) {
    this.searchString = event;
    if (this.searchString !== "" && this.searchString !== null) {
      this.state.skip = 0;
    }
    this.loadData();
  }
  selectedDataChange(event: any) {
    this.selectedRecord = event.selectedRows[0].dataItem;
  }
  openDialogWithTemplateRef(templateRef: TemplateRef<any>, dataItem: any) {
    this.api.getByIdError(dataItem.ErrorId).subscribe(
      (res) => {
        if ((res['Success'] = true)) {
          this.selectdErrorData = res['Data'];
          this.dialogRef = this.dialog.open(templateRef, {
            disableClose: true,
            autoFocus: false,
          });
        } else {
          this.selectdErrorData = [];
          this.toaster.error('Error');
        }
      },
      (err) => {
        this.LoaderService.hide();
        this.toaster.error('Something went wrong Record not Updated sorry');
      }
    );
  }
  closeDialog() {
    this.dialogRef.close();
  }

  onColumnVisibilityChange(columnEvent: GridComponent): void {
    this.gridSettings.saveGridSettings(columnEvent, this.TableName).subscribe();
  }

  ngAfterViewInit(): void {
    this.gridSettings.applyGridSettings(this.api, this.TableName, this.gridKendo);
  }
}
